
export default function SocialProof() {
  const testimonials = [
    {
      text: 'Seit ich bei Theresa Mühlbacher in Behandlung bin, habe ich meine chronischen Rückenschmerzen zu 80% reduziert. Die Kombination aus manueller Therapie und gezielten Übungen hat mir enorm geholfen. Absolut empfehlenswert!',
      author: 'Michael Weber',
      role: 'Büroangestellter',
      rating: 5
    },
    {
      text: 'Nach meiner Knie-OP war ich skeptisch, ob ich jemals wieder Sport treiben kann. Dank der professionellen Sportphysiotherapie bin ich heute fitter als zuvor. Die Betreuung war erstklassig!',
      author: 'Sandra Hoffmann',
      role: 'Hobbysportlerin',
      rating: 5
    },
    {
      text: 'Die kurzen Wartezeiten und die flexible Terminvergabe haben mich begeistert. Endlich eine Praxis, die sich nach meinem Zeitplan richtet. Die Behandlungen sind immer punktgenau und effektiv.',
      author: 'Thomas Gruber',
      role: 'Selbstständiger',
      rating: 5
    }
  ];

  return (
    <section id="bewertungen" className="py-28 bg-olive-50/50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <span className="text-gold-500 text-sm font-medium tracking-[0.2em] uppercase mb-4 block">
            Erfahrungen
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold text-olive-900 mb-4">
            Das sagen unsere Patienten
          </h2>
          <div className="w-16 h-px bg-gold-300 mx-auto mb-6"></div>
          <p className="text-lg text-olive-700 max-w-2xl mx-auto font-light">
            Echte Erfahrungen von Menschen, denen wir helfen durften.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white p-8 md:p-10 rounded-3xl shadow-sm hover:shadow-2xl transition-all duration-500 border border-olive-100 group"
            >
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-gold-400 text-xl"></i>
                ))}
              </div>
              <p className="text-olive-700 leading-relaxed mb-8 font-light italic">
                "{testimonial.text}"
              </p>
              <div className="border-t border-olive-100 pt-6">
                <p className="font-semibold text-olive-900">
                  {testimonial.author}
                </p>
                <p className="text-sm text-olive-500">
                  {testimonial.role}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-24 bg-olive-900 rounded-3xl p-12 md:p-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="font-serif text-4xl md:text-5xl font-semibold text-gold-300 mb-3">200+</div>
              <div className="text-white/80 text-sm font-light tracking-wide">Zufriedene Patienten</div>
            </div>
            <div className="text-center">
              <div className="font-serif text-4xl md:text-5xl font-semibold text-gold-300 mb-3">10+</div>
              <div className="text-white/80 text-sm font-light tracking-wide">Jahre Erfahrung</div>
            </div>
            <div className="text-center">
              <div className="font-serif text-4xl md:text-5xl font-semibold text-gold-300 mb-3">24/7</div>
              <div className="text-white/80 text-sm font-light tracking-wide">Online Terminbuchung</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
